import React, { Component, Fragment } from 'react'
import styled from 'styled-components'
import type { IntlShape } from 'react-intl'
import { FormattedMessage, injectIntl } from 'react-intl'
import {
    CatalogGroupOptions,
    CatalogStepper
} from 'app/ecommerce/common/components/catalog'
import { updateOrderProductOption } from 'shared/utils/ecommerce/utils'
import type { PurchasableItem } from 'shared/store/ecommerce/order'
import type { Option } from 'shared/store/ecommerce/catalog'
import { H5 } from 'app/common/typography'

type Props = {
    intl: IntlShape,
    order: ?PurchasableItem,
    isFromCart: boolean,
    listOptions: Array<Array<Option>>,
    dispatchOrder: (order: ?PurchasableItem) => void
}

class _CatalogStepperOptions extends Component<Props> {
    updateOrderOption = (
        idOption: string,
        quantity?: number,
        quantityInit: number,
        name: string,
        index?: number,
        idToRemove?: string
    ) => {
        const { order, dispatchOrder } = this.props
        dispatchOrder(
            updateOrderProductOption(
                order,
                idOption,
                quantity,
                quantityInit,
                name,
                index,
                idToRemove
            )
        )
    }

    renderStepper = (option: Option) => {
        const { order, isFromCart } = this.props
        const { id, name, image, quantityMax, quantityInit = 0 } = option
        const optionFromOrder =
            order &&
            order.options &&
            order.options.find(option => option.id === id)
        const quantity = isFromCart
            ? optionFromOrder?.quantity || 0
            : quantityInit

        return (
            <CatalogStepper
                id={id}
                name={name}
                quantityInit={quantity}
                quantityMax={quantityMax}
                quantityMin={0}
                onQuantityChange={(quantity: number) =>
                    this.updateOrderOption(id, quantity, quantityInit, name)
                }
                imageUrl={image}
            />
        )
    }

    render() {
        const { listOptions } = this.props
        const availableOptions = listOptions.map(options =>
            options.filter(option => option.available && option.active)
        )

        return (
            <Fragment>
                <TilesContainer>
                    {availableOptions.length === 1 &&
                    availableOptions[0].length === 1
                        ? this.renderStepper(availableOptions[0][0])
                        : availableOptions.map((options, index) => {
                              return (
                                  <Fragment key={index}>
                                      {availableOptions.length > 1 && (
                                          <FormattedMessage
                                              id="clickandcollect.stepper.choice"
                                              values={{ index: index + 1 }}>
                                              {(text: string) => (
                                                  <StyledH5>{text}</StyledH5>
                                              )}
                                          </FormattedMessage>
                                      )}
                                      <CatalogGroupOptions
                                          listOptions={options}
                                          index={index}
                                          updateOrderOption={
                                              this.updateOrderOption
                                          }
                                      />
                                  </Fragment>
                              )
                          })}
                </TilesContainer>
            </Fragment>
        )
    }
}

const TilesContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    flex-wrap: wrap;
    margin-bottom: 20px;
    width: 100%;
`

const StyledH5 = styled(H5)`
    margin-bottom: 10px;
`

const CatalogStepperOptions = injectIntl(_CatalogStepperOptions)

export { CatalogStepperOptions }
